module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAWCAYAAADq8U2pAAAAAXNSR0IArs4c6QAAAExJREFUCB11jlEKACAIQ02G5+r+RxLRtKg+Ir/Gm9O1iOiUA3dfQlWJmQlmVg6hyBEf613eJAO84gCumHdE5JL54pAS2Yky9Eu1XX4AVLIoFzmZPU4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-spliter.png
// module id = 1080
// module chunks = 0